const STANDARD_TRAVEL_MODULE_ID = "standard_insurance-7f3ac912-5b8d-4e2a-a91f-c6d84b72e4a9";
const MTEK_TRAVEL_MODULE_ID = "mtek-dbbcd171-aa7c-4405-ad9c-4f8ab9ee0007";

export {
    STANDARD_TRAVEL_MODULE_ID,
    MTEK_TRAVEL_MODULE_ID
}
    